import { AdminGuard } from 'app/core/auth/guards/admin.guard';
import { AuthEmailVerificationComponent } from './modules/auth/email-verification/email-verification.component';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'profile/'+localStorage.getItem('user-id')},

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'profile/'+localStorage.getItem('user-id')},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            { path: 'reset-password/:id/:token', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            { path: 'verificar-cuenta/:id/:verification_token', loadChildren: () => import('app/modules/auth/email-verification/email-verification.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: '404', loadChildren: () => import('app/modules/errors/404/404.routes')},
            { path: '403', loadChildren: () => import('app/modules/errors/403/403.routes')},
        ]
    },

    // Admin routes (solo admin)
    {
        path: '',
        canActivate: [AuthGuard, AdminGuard],
        canActivateChild: [AuthGuard, AdminGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'admin/activity-codes', loadChildren: () => import('app/modules/admin/activity-codes/activity-codes.routes')},
            {path: 'admin/bill', loadChildren: () => import('app/modules/admin/bill/bill.routes')},
            {path: 'admin/calculator', loadChildren: () => import('app/modules/admin/calculator/calculator.routes')},
            {path: 'admin/clients', loadChildren: () => import('app/modules/admin/clients/clients.routes')},
            {path: 'admin/consolidations', loadChildren: () => import('app/modules/admin/consolidations/consolidations.routes')},
            {path: 'admin/dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},
            {path: 'admin/fees', loadChildren: () => import('app/modules/admin/fees/fees.routes')},
            {path: 'admin/heroes', loadChildren: () => import('app/modules/admin/heroes/heroes.routes')},
            {path: 'admin/invoices', loadChildren: () => import('app/modules/admin/invoices/invoices.routes')},
            {path: 'admin/monto-manejo', loadChildren: () => import('app/modules/admin/management-amount/management-amount.routes')},
            {path: 'admin/notifications', loadChildren: () => import('app/modules/admin/notifications/notifications.routes')},
            {path: 'admin/packages', loadChildren: () => import('app/modules/admin/packages/packages.routes')},
            {path: 'admin/plan-requests', loadChildren: () => import('app/modules/admin/plan-requests/plan-requests.routes')},
            {path: 'admin/plans', loadChildren: () => import('app/modules/admin/plans/plans.routes')},
            {path: 'admin/prealert', loadChildren: () => import('app/modules/admin/packages/prealert/prealert.routes')},
            {path: 'admin/prealerts', loadChildren: () => import('app/modules/admin/prealerts/prealerts.routes')},
            {path: 'admin/quotations', loadChildren: () => import('app/modules/admin/quotations/quotations.routes')},
            {path: 'admin/restricted', loadChildren: () => import('app/modules/admin/restricted-packages/restricted-packages.routes')},
            {path: 'admin/search', loadChildren: () => import('app/modules/admin/search/search.routes')},
            {path: 'admin/tipo_cambio', loadChildren: () => import('app/modules/admin/exchange/exchange.routes')},
            {path: 'admin/users', loadChildren: () => import('app/modules/admin/users/users.routes')},
        ]
    },

    // Client routes (autenticados)
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'calculator', loadChildren: () => import('app/modules/clients/calculator/calculator.routes')},
            {path: 'consolidations', loadChildren: () => import('app/modules/clients/consolidations/consolidations.routes')},
            {path: 'dashboard', loadChildren: () => import('app/modules/clients/dashboard/dashboard.routes')},
            {path: 'invoices', loadChildren: () => import('app/modules/clients/invoices/invoices.routes')},
            {path: 'packages', loadChildren: () => import('app/modules/clients/packages/packages.routes')},
            {path: 'plans', loadChildren: () => import('app/modules/clients/plans/plans.routes')},
            {path: 'prealert', loadChildren: () => import('app/modules/clients/packages/prealert/prealert.routes')},
            {path: 'prealerts', loadChildren: () => import('app/modules/clients/prealerts/prealerts.routes')},
            {path: 'profile/:id', loadChildren: () => import('app/modules/clients/profile/profile.routes')},
        ]
    }
];
